import { Address } from 'viem';

export const formatDisplayAddress = (account: Address | undefined): string => {
  if (!account) return '';
  return `${account.slice(0, 6)}...${account.slice(-3)}`;
};
